var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorOnboardingSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 285.053,
    height: 339.691,
    viewBox: "0 0 285.053 339.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "undraw_completing_re_i7ap (1)",
    transform: "translate(.037 .025)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12704",
    d: "M479.171 534.955a31.434 31.434 0 0 0-22.55-9.2h-.334a32.2 32.2 0 0 1-16.232-4.383l-.513-.3.413-.425a31.384 31.384 0 0 0 5.535-7.836 9.49 9.49 0 0 1-7.659 2.474 9.717 9.717 0 0 1-7.134-4.569c-3.026-4.91-6.634-11.878-6.634-17.185A32.3 32.3 0 0 1 434.6 469.7a20.112 20.112 0 0 0 6.644-15v-.4a45.627 45.627 0 0 1 1.356-11.044l.09-.358.375.013a30.836 30.836 0 0 0 7.21-.6 24.338 24.338 0 0 1-6.466-1.72l-.4-.163.137-.413c9.44-5.845 30.749-2.818 43.117-31.116 10.029-22.946 45.415 20.369 45.415 45.406 0 2.555-2.528 5.931-.636 7.619 20.46 18.253 6.343 29.974 1.892 41.769-1.056 2.8 1.234 5.87 1.234 8.9 0 .514-.013 1.044-.039 1.576l-.039.818-.682-.454a22.6 22.6 0 0 1-3.732-3.061 19.692 19.692 0 0 1-.625 17c-2.144 4.047-4.219 6.944-6.165 8.611a32.192 32.192 0 0 1-44.11-2.119z",
    transform: "translate(-368.794 -256.173)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12705",
    d: "M575.968 671.79a.58.58 0 0 0 .573-.5 194.03 194.03 0 0 0 .27-40.681c-2-21.348-8.424-52.1-27.666-77.349a.58.58 0 1 0-.922.7c19.077 25.04 25.449 55.562 27.435 76.759a192.718 192.718 0 0 1-.264 40.409.58.58 0 0 0 .574.661z",
    transform: "translate(-431.337 -332.124)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12706",
    d: "M514.21 610.671a.579.579 0 0 0 .341-1.048 79.87 79.87 0 0 0-17.633-8.976c-9.728-3.562-24.522-6.79-39.751-1.943a.579.579 0 1 0 .351 1.1c14.917-4.747 29.443-1.572 39 1.928a78.559 78.559 0 0 1 17.35 8.825.577.577 0 0 0 .342.114z",
    transform: "translate(-385.282 -353.912)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12707",
    d: "M608.356 491.468a.579.579 0 0 0-1.021-.416 79.87 79.87 0 0 0-10.222 16.941c-4.253 9.447-8.539 23.969-4.8 39.508a.579.579 0 1 0 1.127-.271c-3.661-15.221.552-29.479 4.731-38.761a78.56 78.56 0 0 1 10.05-16.669.577.577 0 0 0 .135-.331z",
    transform: "translate(-452.905 -300.768)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12708",
    d: "M792.64 741.36h-46.133l-.2-.36c-.59-1.07-1.159-2.2-1.692-3.368-4.752-10.173-6.76-21.809-8.533-32.074l-1.334-7.738a4.778 4.778 0 0 1 7.521-4.674q10.516 7.652 21.041 15.29c2.657 1.933 5.691 4.17 8.6 6.588.28-1.362.574-2.727.867-4.074a4.781 4.781 0 0 1 8.731-1.51l5.4 8.672c3.937 6.333 7.411 12.573 6.7 19.3a1.048 1.048 0 0 1-.018.244 15.215 15.215 0 0 1-.783 3.24z",
    transform: "translate(-525.41 -402.308)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12709",
    d: "m788.169 387.873-8.9-32.954a5.51 5.51 0 0 0-6.683-3.884 5.51 5.51 0 0 0-3.888 6.987l10.3 33.947 5.388 20.891a4.808 4.808 0 1 0 6.165.275z",
    transform: "translate(-542.432 -230.186)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12710",
    d: "m624.818 379.992 27.052-20.819a5.51 5.51 0 0 0 1.036-7.66 5.51 5.51 0 0 0-7.942-.924l-27.437 22.487-17.248 12.961a4.808 4.808 0 1 0 2.1 5.8z",
    transform: "translate(-454 -229.403)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12711",
    d: "m700.38 419.346-1.192 26.631 37.44-8.137c-3.187-10.7-5.354-12.526-2.959-19.973z",
    transform: "translate(-507.514 -263.971)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12712",
    d: "M717.425 322.378H704.95l-5.357 9.168-2.553-.141a9.2 9.2 0 0 0-9.7 9.183l3.145 4.875s-5.625 9.8 2.478 14.626c0 0-1.445 9.087 0 8.989s4.774-1.947 1.445-.1-3.08 2.1-2.65 2.528l.431.431 35 5.878s1.024-6.786 1.134-8-.629 1.749.11-1.21 1.849-1.849.74-2.959 7.19-14.857 3.78-20.189l5.467-5.332c0-5.115-8.215-9.262-13.33-9.262h-.655z",
    transform: "translate(-501.538 -215.825)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12713",
    d: "M367.274 643.371h-5.05l-2.4-19.476h7.452z",
    transform: "translate(-181.444 -314.586)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12714",
    d: "M656.646 775.047a2.148 2.148 0 0 0 2.134 2.138h9.505l.294-.61 1.344-2.774.521 2.774.115.61h3.585l-.051-.615-.956-11.464-1.251-.077-5.4-.32-1.327-.081v3.423c-1.01 1.072-8.914 5.123-8.513 6.996z",
    transform: "translate(-486.057 -438.812)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12715",
    d: "m509.121 619.844-4.246 2.732-12.558-15.076 6.268-4.031z",
    transform: "translate(-248.249 -304.285)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12716",
    d: "M820.778 755.633a2.148 2.148 0 0 0 2.952.644l7.994-5.143-.083-.673-.37-3.061 1.939 2.051.427.451 3.015-1.94-.376-.489-7.007-9.124-1.093.612-4.718 2.654-1.16.65 1.852 2.879c-.267 1.447-4.723 9.13-3.372 10.489z",
    transform: "translate(-568.693 -425.562)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12717",
    d: "m726.66 790.841-156.352.152a.59.59 0 0 1 0-1.181l156.352-.152a.59.59 0 0 1 0 1.181z",
    transform: "translate(-442.234 -451.433)",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12718",
    d: "M718.329 452.085s-23.932 12.659-36.591 4.022c0 0-2.769 13.411-3.879 14.521s-2.878 1.593-1.624 2.831 1.952 2.909-.432 5.033-4.76 1.449-2.462 3.636-6.949 55.818-6.949 55.818 1.479 49.876 0 51.384-3.457 1.846-1.544 3.712 1.913.419 1.913 2.991v2.573l.875 2.557h12.01s2.9-3.367 0-6.291.882-3.724 1.766-6.468 2.363.215.884-2.744-2.19-2.4-2.2-4.342 21.808-78.14 21.808-78.14l2.643 42.173 31.793 46.186 9.358-7.018s-6.813-9.591-5.22-10.91-4.7-2.972-2.713-4.46-2.791-2.986-.992-4.958-2.479-6.941-4.958-6.941-5.958-8.284-5.958-8.284l5.193-65.44z",
    transform: "translate(-489.802 -281.225)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12719",
    d: "M709.194 267.791c-.169.222-1.519.1-3.141-.134-3.208-.468-3.646.088-6.044 2.27-3.474 3.16-1.5 22.436-3.206 26.612l-.552.406a19.84 19.84 0 0 0 3.212-.9c.59-1.86 1.181-3.726 1.776-5.584a16.356 16.356 0 0 1 1.049 4.51 25.2 25.2 0 0 1 5.1-2.19c1.738-1.179 14.309-2.364 15.925-2.883 4.1-13.954-2.513-19.598-14.119-22.107z",
    transform: "translate(-506.033 -188.156)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2934",
    cx: 12.014,
    cy: 12.014,
    r: 12.014,
    transform: "translate(195.392 77.127)",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12720",
    d: "M743.325 259.745a5.366 5.366 0 0 1-1.92-.673 1.826 1.826 0 0 1-.874-1.728 1.846 1.846 0 0 1 1.978-1.311 5.381 5.381 0 0 1 2.384.965 3.7 3.7 0 0 0-3.148-3.311 7.671 7.671 0 0 1 3.371.322 2.624 2.624 0 0 1 1.738 2.644 4.309 4.309 0 0 1 4.242 2.631 7.166 7.166 0 0 1 0 5.221 1.844 1.844 0 0 1-.924 1.222 1.977 1.977 0 0 1-1.751-.526 41.869 41.869 0 0 1-7.3-6.744",
    transform: "translate(-528.356 -181.17)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12721",
    d: "M729.475 284.074c-.509.24-.244 1.132-.64 1.531a1.628 1.628 0 0 1-.607.377 7.3 7.3 0 0 0-.514-2.167c-.052-.126-.137-.266-.27-.255-.155.018-.2.222-.2.374a6.267 6.267 0 0 1-.492 2.186c0 .007-.007.018-.011.026l-.344-.011c-.858-.033-2.759-2.238-3.181-1.491 1.487-2.637 3.3-6.6 3.577-9.617a4.265 4.265 0 0 0-.137-1.886 1.667 1.667 0 0 0-1.387-1.147 1.061 1.061 0 0 0-1.1 1.213l-.215-.03c-1.99-1.62-.274-4.435-2.589-5.548-.784-.377-5.585.884-6.432.662a7.289 7.289 0 0 0-.536-2.6c-.052-.126-.137-.266-.27-.255-.155.018-.2.222-.2.374a6.268 6.268 0 0 1-.492 2.186 9.161 9.161 0 0 0-3.517.185c-1.013.266-1.975.725-2.992.969a3.869 3.869 0 0 1-3.04-.333 3.425 3.425 0 0 1-.873-4.194 8.259 8.259 0 0 1 1.857-2.4c.581-.562 1.184-1.1 1.786-1.642l1.62-1.454a19.748 19.748 0 0 1 2.167-1.768 10.694 10.694 0 0 1 8.348-1.457c1.7.407 3.976-.166 5.533.629a32.782 32.782 0 0 1 3.329 2.589c1.827 1.454.591.269 2.589 1.11 4.768 2.006 2.658 22.23-.767 23.844z",
    transform: "translate(-509.268 -182.161)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2935",
    cx: 74.504,
    cy: 74.504,
    r: 74.504,
    transform: "translate(12.685 40.591)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12722",
    d: "M411.92 338.331a75.247 75.247 0 1 1 75.247-75.247 75.333 75.333 0 0 1-75.247 75.247zm0-149.008a73.76 73.76 0 1 0 73.76 73.76 73.844 73.844 0 0 0-73.76-73.759z",
    transform: "translate(-324.731 -147.988)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12723",
    d: "M438.846 338.948a8.285 8.285 0 0 1-6.629-3.316l-20.326-27.1a8.287 8.287 0 1 1 13.26-9.944l13.3 17.729 34.154-51.23a8.288 8.288 0 1 1 13.792 9.194l-40.651 60.977a8.291 8.291 0 0 1-6.666 3.688z",
    transform: "translate(-361.821 -185.076)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2936",
    cx: 2.606,
    cy: 3.747,
    rx: 2.606,
    ry: 3.747,
    transform: "matrix(.144 -.99 .99 .144 156.16 46.747)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2937",
    cx: 2.606,
    cy: 3.747,
    rx: 2.606,
    ry: 3.747,
    transform: "rotate(-81.72 115.865 -82.13)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2938",
    cx: 2.606,
    cy: 3.747,
    rx: 2.606,
    ry: 3.747,
    transform: "rotate(-81.72 90.316 -72.864)",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2939",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 81.646 -62.376)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2940",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 72.26 -68.094)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2941",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 99.585 -68.924)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2942",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 96.659 -60.045)",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2943",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 110.338 -62.875)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2944",
    cx: 2.606,
    cy: 3.747,
    rx: 2.606,
    ry: 3.747,
    transform: "rotate(-81.72 137.15 102.134)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2945",
    cx: 2.606,
    cy: 3.747,
    rx: 2.606,
    ry: 3.747,
    transform: "rotate(-81.72 147.961 86.86)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2946",
    cx: 2.606,
    cy: 3.747,
    rx: 2.606,
    ry: 3.747,
    transform: "rotate(-81.72 122.412 96.126)",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2947",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 100.7 96.34)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2948",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 91.315 90.622)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2949",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 118.64 89.792)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2950",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 115.714 98.67)",
    style: {
      fill: "#ff6584"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2951",
    cx: 2.368,
    cy: 1.647,
    rx: 2.368,
    ry: 1.647,
    transform: "rotate(-89.54 129.393 95.84)",
    style: {
      fill: "#3f3d56"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorOnboardingSuccess);
export default __webpack_public_path__ + "static/media/VendorOnboardingSuccess.00c2f76dcc19dc6e0eb7c307239bbc23.svg";
export { ForwardRef as ReactComponent };